export async function addNewOrder(createOrderDto) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Order/Create`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(createOrderDto),
      }
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP ! statut : ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      return null;
    }
    console.error("Erreur lors de l'ajout d'une commande :", error);
    throw error;
  }
}
